import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link } from "react-router-dom";
import service from "../../assets/images/resource/DSP.jpg";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/DSC.png";

const Cloud = () => {
  pageTitle("Data Science with Python - Course Overview");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setFormData({
      name: "",
      email: "",
      subject: "",
      phone: "",
      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/rpa-training" },
    { id: 2, title: "Python & SQL", slug: "/python" },
    { id: 3, title: "Data Science With Python", slug: "/cloud" },
    {
      id: 4,
      title: "Cloudera Data Engineering",
      slug: "/data-engineering-course",
    },
    { id: 5, title: "Cloudera Data analyst", slug: "/data-analyst" },
    { id: 6, title: "Cloudera AI", slug: "/AI" },

    { id: 7, title: "Cloudera ML", slug: "/machine-learning" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li key={service.id}>
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  // Helper to extract YouTube video ID from Shorts URL
  const getYouTubeVideoId = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    let id = parts[parts.length - 1];
    if (id.includes("?")) {
      id = id.split("?")[0];
    }
    return id;
  };
  // Updated course details array for Data Science with Python.
  const courseDetails = [
    {
      number: 1,
      title: "Introduction to Data Science and Its Importance",
      topics:
        "Data Science is transforming industries by enabling data-driven decision-making. Explore real-world applications and career opportunities.",
      youtubeShort:
        "https://youtube.com/shorts/_b3PXSJDQf0?si=OqUxaOB0gD647tZF",
    },
    {
      number: 2,
      title: "Role of Python in AI and Data Science",
      topics:
        "Learn why Python is the most preferred language for AI and Data Science with its vast libraries and supportive community.",
      youtubeShort: "https://youtu.be/UXADcP4yerk?si=ZqnSs1ViwL8zGWr7",
    },
    {
      number: 3,
      title: "Step-by-Step Guide to Building Machine Learning Models",
      topics:
        "Covering the end-to-end process from data collection to model deployment, including preprocessing and hyperparameter tuning.",
      youtubeShort: "https://youtu.be/k1HquDaSagc?si=sySkMzzLJsiFqVgl",
    },
    {
      number: 4,
      title: "The Importance of Data Preprocessing in Machine Learning",
      topics:
        "Focus on handling missing values, outliers, duplicates, and encoding categorical variables to refine your data.",
      youtubeShort: "https://youtu.be/GCd88NHY4u8?si=WbADi412EK4OVmW8",
    },
    {
      number: 5,
      title: "How Machine Learning Powers Spam Detection",
      topics:
        "Discover how algorithms like Naïve Bayes, Logistic Regression, and Neural Networks help in detecting spam and phishing.",
      youtubeShort: "https://youtu.be/nHRoQB3X1h4?si=dKZTey0GgXcwse60",
    },
    {
      number: 6,
      title:
        "Understanding the Difference Between Data Science and Machine Learning",
      topics:
        "Clarify the roles where Data Science covers data processing, visualization, and statistics, while Machine Learning builds predictive models.",
      youtubeShort: "https://youtu.be/BhPyVou1GQU?si=UfHo31rzVT2h0LkF",
    },
    {
      number: 7,
      title: "Introduction to Data Visualization and Its Types",
      topics:
        "Learn about various visualizations like bar charts, histograms, scatter plots, heatmaps, and box plots using Python libraries.",
      youtubeShort: "https://youtu.be/Nz1i2WHI7kI?si=xvAsQHOCkegrvmur",
    },
    {
      number: 8,
      title: "Transforming Raw Data into Insights with Data Visualization",
      topics:
        "See real-world examples where effective visualizations lead to meaningful business insights and impactful dashboards.",
      youtubeShort: "https://youtu.be/YNwsxqJoyxA?si=QhxmLYBe3affpGXs",
    },
    {
      number: 9,
      title: "Regression: Predicting Values Based on Data Patterns",
      topics:
        "Dive into Linear and Multiple Regression using Scikit-Learn to predict outcomes like house prices.",
      youtubeShort: "https://youtu.be/5oFN8Zn9OTY?si=GglG3ysHrdOu9T-E",
    },
    {
      number: 10,
      title: "Classification Models for Decision Making in AI",
      topics:
        "Explore Decision Trees, Random Forest, and Support Vector Machines for fraud detection and medical diagnosis.",
      youtubeShort: "https://youtu.be/SHW12coYch0?si=7KHwIzbZZUXfMluh",
    },
    {
      number: 11,
      title: "Support Vector Machines (SVM) for Classification",
      topics:
        "Learn how SVM finds the best boundaries to separate classes and its application in various classification tasks.",
      youtubeShort:
        "https://youtube.com/shorts/4A082OtChI8?si=1SRVRc2-kOF8fv2_",
    },
    {
      number: 12,
      title: "Decision Trees: Simple and Effective Predictions",
      topics:
        "Understand how decision trees use a series of YES/NO questions to make predictions and measure accuracy with entropy and Gini.",
      youtubeShort: "https://youtu.be/PU9UvAmIn8M?si=N83-S2LJ4gL4mChD",
    },
    {
      number: 13,
      title: "Optimizing Decision Trees with Better Splitting Techniques",
      topics:
        "Explore how information gain and entropy help decision trees make smarter, more accurate splits.",
      youtubeShort: "https://youtu.be/Ds2MqZg0xuI?si=_RfSVaO12e6aspNs",
    },
    {
      number: 14,
      title: "Random Forest: Improving Accuracy with Multiple Trees",
      topics:
        "Learn how combining multiple decision trees in a random forest boosts accuracy and prevents overfitting.",
      youtubeShort: "https://youtu.be/OVb3L1Seu9U?si=d7TIPJ-MzxoNQqH8",
    },
    {
      number: 15,
      title: "Dimensionality Reduction: Simplifying Complex Data",
      topics:
        "Discover Principal Component Analysis (PCA) and t-SNE to reduce features while preserving essential information.",
      youtubeShort: "https://youtu.be/jlJm8V5MSyw?si=zepA-l_vi-DUw_Wc",
    },
    {
      number: 16,
      title: "Hierarchical Cluster Analysis (HCA): Grouping Data Step by Step",
      topics:
        "Examine how HCA organizes data into tree-like structures, showing relationships between groups via dendrograms.",
      youtubeShort: "https://youtu.be/fLGIe-mLFnc?si=FAzzItrxAhGOdjpT",
    },
    {
      number: 17,
      title: "K-Means Clustering: Finding Patterns in Data",
      topics:
        "Understand the K-Means algorithm, centroids, and how to select the right number of clusters for segmentation.",
      youtubeShort: "https://youtu.be/IbzZJ3pIvzw?si=mwzTR_ARUANRj7yV",
    },
    {
      number: 18,
      title: "Principal Component Analysis (PCA): Reducing Data Complexity",
      topics:
        "Learn how PCA simplifies datasets by reducing features while preserving important insights for visualization.",
      youtubeShort: "https://youtu.be/h85n3ZwLXkI?si=FFzcyt20NpNgC_ce",
    },
    {
      number: 19,
      title:
        "Linear Discriminant Analysis (LDA): Improving Classification Accuracy",
      topics:
        "Explore how LDA maximizes class separability and enhances classification models in fields like face recognition.",
      youtubeShort: "https://youtu.be/GOeX1Q4kCyQ?si=fw-DMIAnC8tUneOU",
    },
    {
      number: 20,
      title: "Statistics & Probability for Data Science",
      topics:
        "Understand key concepts such as mean, median, variance, standard deviation, and hypothesis testing for building models.",
      youtubeShort: "https://youtu.be/_6vX9tpdHYo?si=HsbFoU1rz2m3P1H6",
    },
  ];
  const featuredYoutubeLink =
    "https://youtube.com/shorts/Di4EvjeGSxc?si=TfpdmJNelCduFqw_";
  const featuredVideoId = getYouTubeVideoId(featuredYoutubeLink);
  const featuredEmbedUrl = `https://www.youtube.com/embed/${featuredVideoId}`;
  return (
    <>
      <Helmet>
        <title>Data Science with Python - Course Overview | SIW</title>
        <meta
          name="description"
          content="Explore Data Science with Python. Learn Python basics, data preprocessing, visualization, machine learning, and more through hands-on projects."
        />
        <meta
          name="keywords"
          content="Data Science, Python, Machine Learning, Data Visualization, Python Basics"
        />
        <meta name="author" content="SIW" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeaderOne />

      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* Breadcrumb and title can be added here if needed */}
          </div>
        </div>
      </section>

      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row">
            {/* Main Content */}
            <div className="col-xl-8 col-lg-12 col-md-12 order-1 order-xl-1">
              <div className="service__right">
                <figure>
                  <img
                    src={service}
                    alt="Data Science with Python Course"
                    className="training-images"
                  />
                </figure>

                <h2>Data Science with Python Course Overview</h2>
                <p>
                  Data Science is transforming industries by enabling
                  data-driven decision-making. This course is designed to
                  provide a practical and comprehensive introduction to data
                  science using Python. You’ll learn how to analyze, visualize,
                  and interpret data, as well as build machine learning models
                  to extract valuable insights. Whether you're a beginner or
                  looking to level up your skills, this journey equips you with
                  the essential tools and techniques to work with real-world
                  data.
                </p>

                <h2>
                  <span>What You’ll Learn</span>
                </h2>
                <ul className="bullet-list">
                  <li>
                    <strong>Python Basics for Data Science:</strong> Learn
                    essential Python libraries like NumPy, Pandas, Matplotlib,
                    and Seaborn.
                  </li>
                  <li>
                    <strong>Data Preprocessing & Cleaning:</strong> Handle
                    missing values, outliers, and format data for analysis.
                  </li>
                  <li>
                    <strong>Data Visualization:</strong> Create meaningful
                    graphs and charts to understand data better.
                  </li>
                  <li>
                    <strong>Statistical Analysis & Probability:</strong> Apply
                    statistical techniques to analyze and interpret data trends.
                  </li>
                  <li>
                    <strong>Machine Learning Fundamentals:</strong> Explore
                    supervised and unsupervised learning techniques.
                  </li>
                  <li>
                    <strong>Regression & Classification:</strong> Build
                    predictive models for various applications.
                  </li>
                  <li>
                    <strong>Clustering & Dimensionality Reduction:</strong>{" "}
                    Organize data into meaningful groups and simplify complex
                    datasets.
                  </li>
                  <li>
                    <strong>Model Evaluation & Optimization:</strong> Improve
                    model accuracy and performance using advanced techniques.
                  </li>
                  <li>
                    <strong>Real-World Projects:</strong> Work on hands-on
                    projects to apply your learning in practical scenarios.
                  </li>
                </ul>
              </div>
            </div>
            <div className="courses col-12 order-2 order-xl-3">
              <h3 style={{ paddingTop: "10px" }}>What to Expect</h3>
              <p>
                This course follows a structured, hands-on approach with a mix
                of theory and practice. You will work on real datasets,
                implement machine learning models, and develop data-driven
                solutions. By the end, you'll be confident in using Python for
                data analysis, machine learning, and making those data-driven
                decisions.
              </p>
              <h3 style={{ paddingTop: "20px" }}>Course Details</h3>
              <ul
                className="course-details-list"
                style={{ listStyle: "none", padding: 0 }}
              >
                {courseDetails.map((item) => {
                  const hasVideo = Boolean(item.youtubeShort);
                  const videoId = getYouTubeVideoId(item.youtubeShort);
                  const thumbnailUrl = videoId
                    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
                    : "";
                  return (
                    <li
                      key={item.number}
                      className="course-detail-item"
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginBottom: "20px",
                        background: "#f9f9f9",
                        padding: "15px",
                        borderRadius: "8px",
                      }}
                    >
                      <div style={{ flex: 1, paddingRight: "30px" }}>
                        <h5 style={{ margin: "0 0 10px", fontWeight: "bold" }}>
                          {item.number}. {item.title}
                        </h5>
                        <p style={{ margin: 0 }}>{item.topics}</p>
                      </div>
                      {hasVideo && thumbnailUrl && (
                        <div
                          className="course-detail-video"
                          style={{
                            position: "relative",
                            minWidth: "120px",
                            marginLeft: "20px",
                          }}
                        >
                          <a
                            href={item.youtubeShort}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "block",
                              position: "relative",
                            }}
                          >
                            <img
                              src={thumbnailUrl}
                              alt={`Youtube Short for ${item.title}`}
                              style={{
                                width: "150px",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                            <div
                              className="play-button"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <polygon points="12,8 24,16 12,24" />
                              </svg>
                            </div>
                          </a>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-12 order-3 order-xl-2">
              <div className="service__details__left">
                <div
                  className="sidebar__widget_network1 p-md-4 p-3"
                  style={{ backgroundImage: `url(${basebg})` }}
                >
                  <h4>Let’s Build Your Skills for the Future</h4>
                  <br></br>
                  <p>
                    From foundational concepts to advanced industry practices,
                    our hands-on training programs empower individuals and teams
                    with practical, job-ready expertise.
                  </p>
                  <br></br>
                  <h4>
                    <span>Call us at</span>{" "}
                    <a href="tel:+6590059743" style={{ color: "#009999" }}>
                      +65 9005 9743
                    </a>{" "}
                    to explore our Data Science with Python Course
                  </h4>
                  <br></br>
                  <a href="/contact" class="siw-rpa-btn">
                    <i className="bi bi-calendar-week btn-icon"></i>
                    Schedule a Meeting
                  </a>
                </div>
                <div className="sidebar__widget">
                  <div className="all__service">
                    <h4>All Courses</h4>
                  </div>

                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-6 col-md-12 order-3 order-xl-2">
              <div className="service__details__left">
               
                <iframe
                  width="100%"
                  height="700"
                  src={featuredEmbedUrl}
                  title="Featured YouTube Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ borderRadius: "8px" }}
                ></iframe>
              
                <div className="sidebar__widget">
                  <div className="all__service mt-50">
                    <h4>All Courses</h4>
                  </div>
                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>

              </div>
            </div> */}
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default Cloud;
